module.exports = __webpack_public_path__ + "img/jk_tab_active.0fb3b9c1.png";